import katex from 'katex'

//create markup from HTML
//(on object we save HTML and we then need to parse it a bit before rendering in slide )


function htmlDecode(input) { //handle inequality signs
	let escapedInput=input.replace(/</g, '&lt')
	escapedInput=escapedInput.replace(/>/g, '&gt')
	var doc = new DOMParser().parseFromString(escapedInput, "text/html")
	return doc.documentElement.textContent
}


function getKatexHTML(latex){
	const parsedLatex=htmlDecode(latex)
	const html = katex.renderToString(parsedLatex, {
	    throwOnError: false,	   
      output: "html",
	})
	return html
}

export default function createMarkup(input) {
	let newHTML=''
	if(input){
		newHTML = input.replace(/<math data-latex="((.|\n)*?)"><\/math>/g,  function (outer, inner){ //find all math nodes and turn them into katex HTML
		const katexHTML=getKatexHTML(inner)
		return `<span class="katexOuterContainer">
				<span class="katexInnerContainer">
					<span class="katexInnerContainer-content">
						${katexHTML}
					</span>
				</span>
			</span>`
	}) 
	}

  return {__html: newHTML}
}
